import axios from "axios";
const printdoc = async ({ doc, details, report, useful }) => {
    try {
        const response = await fetch('http://127.0.0.1:5000/print', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                doc: doc,
                details: details,
                report: report,
                useful: useful
            }),
            // 关键：声明目标是本地回环地址，请求 LNA 权限
            targetAddressSpace: 'loopback' 
        });

        if (!response.ok) {
            throw new Error(`打印服务返回错误: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('打印指令发送成功:', result);

    } catch (error) {
        // 更细致的错误处理，方便定位问题
        if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
            alert('无法连接到打印服务。请确保：\n1. 打印服务程序已启动\n2. 已允许本地网络访问权限\n3. 防火墙未阻止连接');
        } else {
            alert('打印请求失败: ' + error.message);
        }
    }
};
export default printdoc
